/* TNF cart drawer no-auto-open (2026-05-12 v6 — DEFAULT-HIDDEN approach).
   HARD RULE: the cart drawer is HIDDEN by default via CSS. The ONLY thing that
   un-hides it is an explicit click on the header cart icon. Add-to-cart from QB
   modal, sticky ATC, PDP, collection cards, etc. — none of those open the drawer.
   They get the yellow cart-icon pulse instead.

   Why CSS-default-hidden instead of close-on-open: the previous JS-close
   approach was racing with the theme's drawer-open code, and on some paths
   (QB form submit on collection pages / homepage) the drawer briefly flashed
   visible before our close fired. CSS-hidden by default = guaranteed invisible
   regardless of when/how the theme tries to open it.
*/
(function () {
  if (window._tnfCartNoAutoOpenInited) return;
  window._tnfCartNoAutoOpenInited = true;

  // 2026-05-18 — Legitimate cart icon click whitelist. The earlier suppression
  // logic was over-aggressive: even a real cart-icon click was being treated as
  // an "auto-open" by downstream handlers (because the `tnf-cart-allow-open`
  // class was being revoked too quickly when only the Oxify drawer — not the
  // theme #mini-cart — was the actual visible drawer). This whitelist gives
  // every suppression handler a single source of truth: "is this event coming
  // from a real cart-icon click?"
  var TNF_CART_ALLOW_SELECTORS = [
    'a.header__cart-toggle',
    '[data-action="toggle-mini-cart"]',
    '[data-oxify-open-cart-bound]',
    '.header__cart-icon',
    '.header__cart-link',
    '.header__action-item--cart',
    '.header__cart-count-wrapper',
    '.header__cart a[href="/cart"]',
    '[aria-controls="mini-cart"]',
    '[aria-controls*="cart-drawer" i]'
  ].join(',');
  function isLegitimateCartIconClick(event) {
    if (!event || !event.target) return false;
    try {
      return !!(event.target.closest && event.target.closest(TNF_CART_ALLOW_SELECTORS));
    } catch (e) { return false; }
  }
  // Expose for any downstream check
  window.__tnfIsLegitimateCartIconClick = isLegitimateCartIconClick;

  // Inject CSS for the cart icon pulse animation — TNF brand yellow (#ffd800),
  // bigger scale, longer duration so it's hard to miss. Runs twice for added emphasis.
  var CSS = ''
    + '@keyframes tnfCartPulse {'
    + '  0%, 100% { transform: scale(1); color: inherit; }'
    + '  20% { transform: scale(1.5) rotate(-6deg); color: #ffd800; }'
    + '  40% { transform: scale(0.9) rotate(6deg); color: #ffd800; }'
    + '  60% { transform: scale(1.35) rotate(-3deg); color: #ffd800; }'
    + '  80% { transform: scale(0.95) rotate(0deg); color: #ffd800; }'
    + '}'
    + '.tnf-cart-pulse { animation: tnfCartPulse 1s cubic-bezier(0.34, 1.56, 0.64, 1); transform-origin: center; }'
    + '@keyframes tnfCartCountPulse {'
    + '  0% { transform: scale(1); background-color: var(--tnf-cart-count-bg, #1e2d7d); color: #fff; box-shadow: 0 0 0 0 rgba(255,216,0,0); }'
    + '  20% { transform: scale(1.8); background-color: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 8px rgba(255,216,0,0.55); }'
    + '  50% { transform: scale(1.3); background-color: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 14px rgba(255,216,0,0); }'
    + '  80% { transform: scale(1.55); background-color: #ffd800; color: #1e2d7d; box-shadow: 0 0 0 6px rgba(255,216,0,0.3); }'
    + '  100% { transform: scale(1); background-color: var(--tnf-cart-count-bg, #1e2d7d); color: #fff; box-shadow: 0 0 0 0 rgba(255,216,0,0); }'
    + '}'
    + '.tnf-cart-count-pulse { animation: tnfCartCountPulse 1.1s cubic-bezier(0.34, 1.56, 0.64, 1); font-weight: 800 !important; }';
  var style = document.createElement('style');
  style.id = 'tnf-cart-no-auto-open-style';
  style.textContent = CSS;
  document.head.appendChild(style);

  var lastCartIconClick = 0;
  var GRACE_MS = 600; // any drawer open within this window after icon click counts as user-initiated

  // Track clicks on the cart icon. Warehouse uses [data-action="toggle-mini-cart"] + aria-controls="mini-cart".
  document.addEventListener('click', function (e) {
    // 2026-05-18 — use the whitelist helper as the single source of truth.
    // Also keep the original a[href="/cart"]:not(.tnf-qbm-cart-view) fallback for
    // any cart-anchored link that isn't the QB modal's "View cart" link.
    var t = isLegitimateCartIconClick(e) || (e.target.closest && e.target.closest(
      '[data-action="toggle-cart"], ' +
      '[data-action="open-cart"], ' +
      'a[href="/cart"]:not(.tnf-qbm-cart-view)'
    ));
    if (t) {
      lastCartIconClick = Date.now();
      // Real user click on the cart icon — un-hide the drawer.
      document.documentElement.classList.add('tnf-cart-allow-open');
      // CRITICAL: clear any inline `display:none` that our MutationObserver set on
      // Oxify / cart-drawer elements while suppressing. Inline beats external CSS,
      // so without this the drawer would stay hidden even with the allow-open class.
      try {
        document.querySelectorAll(
          '[id*="oxify" i], [id*="ia-upsell" i], [class*="oxify" i],' +
          '[class*="ia-upsell" i], [class*="cart-drawer" i], [class*="cart-popup" i],' +
          '[class*="cart-modal" i], [class*="sidecart" i], #mini-cart, .mini-cart'
        ).forEach(function (el) {
          if (el.style && el.style.display === 'none') el.style.removeProperty('display');
        });
      } catch (er) {}
    }
    // Also un-hide if user clicks /cart link from inside the QB modal's "View cart →"
    var viewLink = e.target.closest && e.target.closest('.tnf-qbm-cart-view, a[href="/cart"]');
    if (viewLink) lastCartIconClick = Date.now();
  }, true);

  // When the drawer is actually closed (X button / overlay click / ESC), revoke
  // the allow-open class so any subsequent auto-open is suppressed again.
  // 2026-05-18 — extended to also watch the Oxify drawer (#ia-upsell-cart-parent-div)
  // which is the actual visible drawer on this store. Previously we only watched
  // the theme's #mini-cart form, which is NEVER opened in practice — that meant
  // the watchDrawerForClose logic was firing revokes incorrectly, immediately
  // re-hiding Oxify via CSS and triggering Oxify's CLOSE sequence.
  // ALSO: don't revoke within 1500ms of a legitimate cart icon click. Some
  // drawers briefly toggle their aria-hidden during the open animation; this
  // grace window prevents a spurious revoke during that animation.
  var REVOKE_GRACE_MS = 1500;
  function anyKnownDrawerOpen() {
    var els = document.querySelectorAll(
      '#mini-cart, .mini-cart, drawer-cart, cart-drawer, #cart-drawer, .drawer--cart,' +
      ' #ia-upsell-cart-parent-div, [id^="ia-upsell"], [class*="oxify-cart"]'
    );
    for (var i = 0; i < els.length; i++) if (isCartDrawerOpen(els[i])) return true;
    // Also infer "open" from body classes set by some apps
    var bc = (document.body.className || '').toLowerCase();
    if (/oxify-open|cart-open|drawer-open|app-cart-open|mini-cart-open|is-mini-cart-open/.test(bc)) return true;
    return false;
  }
  function watchDrawerForClose() {
    var d = findCartDrawer();
    if (!d) { setTimeout(watchDrawerForClose, 1000); return; }
    function maybeRevoke() {
      if (!document.documentElement.classList.contains('tnf-cart-allow-open')) return;
      // Grace window after icon click — drawer open animation can flip attributes
      if (Date.now() - lastCartIconClick < REVOKE_GRACE_MS) return;
      if (anyKnownDrawerOpen()) return;
      // Tiny delay so the close animation completes before re-hiding via CSS
      setTimeout(function () {
        if (Date.now() - lastCartIconClick < REVOKE_GRACE_MS) return;
        if (!anyKnownDrawerOpen()) document.documentElement.classList.remove('tnf-cart-allow-open');
      }, 350);
    }
    new MutationObserver(maybeRevoke).observe(d, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
    // Also observe the Oxify drawer if present
    var oxify = document.querySelector('#ia-upsell-cart-parent-div, [id^="ia-upsell"], [class*="oxify-cart"]');
    if (oxify) {
      new MutationObserver(maybeRevoke).observe(oxify, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open', 'style'] });
    }
  }
  // Run after DOM ready since findCartDrawer needs the form element
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerForClose);
  } else {
    watchDrawerForClose();
  }

  function findCartDrawer() {
    // The Warehouse theme cart drawer is `<form id="mini-cart" class="mini-cart" aria-hidden="false|true">`.
    // Also try a few generic fallbacks for safety.
    return document.querySelector(
      '#mini-cart, .mini-cart, drawer-cart, cart-drawer, #cart-drawer, .drawer--cart, [data-drawer="cart"]'
    );
  }

  function isCartDrawerOpen(d) {
    if (!d) return false;
    return d.classList.contains('is-open')
        || d.classList.contains('drawer--open')
        || d.classList.contains('is-active')
        || d.getAttribute('aria-hidden') === 'false'
        || d.hasAttribute('open');
  }

  function closeCartDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open', 'drawer--open', 'is-active', 'mini-cart--open');
    d.setAttribute('aria-hidden', 'true');
    d.removeAttribute('open');
    // Also flip aria-expanded on the toggle button to false (Warehouse uses this)
    document.querySelectorAll('[aria-controls="mini-cart"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.header__cart-icon[aria-expanded]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    var closer = d.querySelector(
      '[data-action="close-mini-cart"], ' +
      '[data-action="close-drawer"], ' +
      '.mini-cart__close, ' +
      '.drawer__close-button, ' +
      '.drawer__close, ' +
      'button[aria-label*="Close" i]'
    );
    if (closer) closer.click();
    document.body.classList.remove('drawer-open', 'cart-drawer-open', 'mini-cart-open', 'overflow-hidden', 'is-mini-cart-open');
  }

  function findCartCountBadge() {
    return document.querySelector(
      '.header__cart-count, ' +
      '[data-cart-count], ' +
      '.header__cart-count-bubble, ' +
      '.header-icons__count, ' +
      '.cart-count-bubble'
    );
  }

  function findCartIcon() {
    return document.querySelector(
      '.header__cart-link, ' +
      '.header__cart-icon, ' +
      '.header-icons__icon--cart, ' +
      'a[href="/cart"]'
    );
  }

  // 2026-05-12 v3: narrow fetch + XHR intercept for /cart/add — needed because
  // the Quick Buy modal's add-to-cart was slipping past the DOM observer
  // (it opens the drawer before our MutationObserver attaches on dynamic mounts).
  // We watch only POSTs that hit /cart/add(.js); narrow enough not to break QB.
  // On every successful add → pulse the cart + actively close any drawer that
  // opens within the next 1.2s.
  (function installCartAddHook() {
    if (window.__tnfCartAddHook) return;
    window.__tnfCartAddHook = 1;
    function isCartAddUrl(u) {
      try {
        if (!u) return false;
        var s = (typeof u === 'string') ? u : (u.url || u.toString() || '');
        return /\/cart\/add(\.\w+)?(\?|$)/.test(s);
      } catch (e) { return false; }
    }
    // v6: DEFAULT-HIDDEN drawer via CSS. The cart drawer is INVISIBLE until
    // <html> has `.tnf-cart-allow-open`. That class is added ONLY when the
    // customer clicks the header cart icon (managed below). Every other path
    // (add-to-cart, QB modal submit, sticky ATC, etc.) gets the yellow icon
    // pulse — but the drawer literally cannot appear on screen.
    if (!document.getElementById('tnf-cart-default-hide-css')) {
      var s = document.createElement('style');
      s.id = 'tnf-cart-default-hide-css';
      // display:none is bulletproof — drawer wrapper can't render at all unless
      // <html> has `.tnf-cart-allow-open`. Includes both the theme drawer AND
      // the Oxify Cart Drawer app embed (which is the actual culprit when add-to-cart
      // pops a drawer on our store — its parent is #ia-upsell-cart-parent-div).
      s.textContent =
        // Theme native drawer
        'html:not(.tnf-cart-allow-open) #mini-cart,' +
        'html:not(.tnf-cart-allow-open) .mini-cart,' +
        'html:not(.tnf-cart-allow-open) drawer-cart,' +
        'html:not(.tnf-cart-allow-open) cart-drawer,' +
        'html:not(.tnf-cart-allow-open) #cart-drawer,' +
        'html:not(.tnf-cart-allow-open) .drawer--cart,' +
        // Oxify Cart Drawer app embed
        'html:not(.tnf-cart-allow-open) #ia-upsell-cart-parent-div,' +
        'html:not(.tnf-cart-allow-open) [id^="ia-upsell" i],' +
        'html:not(.tnf-cart-allow-open) [id*="oxify" i]:not([id*="setting" i]),' +
        'html:not(.tnf-cart-allow-open) [class*="oxify-cart" i],' +
        'html:not(.tnf-cart-allow-open) [class*="oxify-drawer" i],' +
        'html:not(.tnf-cart-allow-open) [class*="ia-upsell" i],' +
        'html:not(.tnf-cart-allow-open) .oxify-upsell-cart,' +
        // Generic catches for any other app-injected cart drawers
        'html:not(.tnf-cart-allow-open) [class*="cart-drawer" i]:not(.tnf-qbm-cart-status):not(.tnf-rv-card),' +
        'html:not(.tnf-cart-allow-open) [class*="cart-popup" i],' +
        'html:not(.tnf-cart-allow-open) [class*="cart-modal" i],' +
        'html:not(.tnf-cart-allow-open) [class*="cart-sidebar" i],' +
        'html:not(.tnf-cart-allow-open) [class*="sidecart" i] {' +
        '  display: none !important;' +
        '}' +
        'html:not(.tnf-cart-allow-open) .modal-overlay,' +
        'html:not(.tnf-cart-allow-open) .drawer__overlay,' +
        'html:not(.tnf-cart-allow-open) [class*="mini-cart-overlay"],' +
        'html:not(.tnf-cart-allow-open) [class*="cart-drawer-overlay" i],' +
        'html:not(.tnf-cart-allow-open) [class*="oxify-overlay" i],' +
        'html:not(.tnf-cart-allow-open) .modal-overlay--mini-cart {' +
        '  display: none !important;' +
        '}' +
        'html:not(.tnf-cart-allow-open) body.mini-cart-open,' +
        'html:not(.tnf-cart-allow-open) body.drawer-open,' +
        'html:not(.tnf-cart-allow-open) body.is-mini-cart-open,' +
        'html:not(.tnf-cart-allow-open) body.oxify-cart-open,' +
        'html:not(.tnf-cart-allow-open) body[class*="cart-open"] {' +
        '  overflow: visible !important;' +
        '}';
      document.head.appendChild(s);
    }
    function fireAfterAdd() {
      pulseCart();
      // No drawer-allow toggle — the drawer stays hidden. Customer sees the pulse.
      try { window.dispatchEvent(new CustomEvent('tnf:cart:item-added')); } catch (e) {}
    }

    // 2026-05-12 v7: defense-in-depth against Oxify Cart Drawer. The app can
    // inject its drawer dynamically (sometimes appended to <body> outside its
    // declared parent), and may set inline display:block !important that beats
    // our external CSS. We watch the entire body for any newly-inserted element
    // whose id/class signals "cart drawer/popup/modal" and force-hide via inline
    // style (which we control). Body class strippers handle the lock-scroll classes.
    var CART_HINT_RE = /(oxify|ia-upsell|cart-drawer|cart-popup|cart-modal|cart-sidebar|sidecart|cart-flyout)/i;
    function _hideOxifyish(node) {
      try {
        if (!node || node.nodeType !== 1) return;
        // If the user clicked cart icon, allow drawers to render.
        if (document.documentElement.classList.contains('tnf-cart-allow-open')) return;
        var combined = ((node.id || '') + ' ' + (node.className || '')).toLowerCase();
        if (CART_HINT_RE.test(combined)) {
          // Whitelist anything that's clearly OUR UI
          if (combined.indexOf('tnf-qbm-cart') !== -1) return;
          if (combined.indexOf('tnf-rv-') !== -1) return;
          node.style.setProperty('display', 'none', 'important');
        }
      } catch (e) {}
    }
    function _stripBodyOpenClasses() {
      if (document.documentElement.classList.contains('tnf-cart-allow-open')) return;
      var bc = (document.body.className || '').toLowerCase();
      if (/oxify-open|cart-open|drawer-open|app-cart-open|mini-cart-open|is-mini-cart-open/.test(bc)) {
        ['oxify-open','cart-open','drawer-open','app-cart-open','mini-cart-open','is-mini-cart-open']
          .forEach(function (c) { document.body.classList.remove(c); });
      }
    }
    function _setupBodyObservers() {
      // 2026-05-13 INP optimization: throttle this observer with rAF batching.
      // Watching childList+subtree on body fires on EVERY DOM mutation across
      // the entire page — that's main-thread cost which was hurting mobile INP.
      // Now we collect mutations in a batch and process them on the next animation
      // frame, and we only inspect nodes that have an id/class containing keywords
      // we care about (fast early-exit via Element.matches selector).
      var _pendingNodes = [];
      var _rafScheduled = false;
      function _flushPending() {
        _rafScheduled = false;
        if (document.documentElement.classList.contains('tnf-cart-allow-open')) {
          _pendingNodes.length = 0; return;
        }
        var nodes = _pendingNodes;
        _pendingNodes = [];
        for (var i = 0; i < nodes.length; i++) _hideOxifyish(nodes[i]);
      }
      new MutationObserver(function (muts) {
        if (document.documentElement.classList.contains('tnf-cart-allow-open')) return;
        var added = false;
        for (var i = 0; i < muts.length; i++) {
          var addedNodes = muts[i].addedNodes;
          for (var j = 0; j < addedNodes.length; j++) {
            var n = addedNodes[j];
            if (n && n.nodeType === 1) {
              // Cheap fast-path filter: only push if id/class looks cart-related
              var sniff = (n.id || '') + ' ' + (n.className || '');
              if (CART_HINT_RE.test(sniff)) { _pendingNodes.push(n); added = true; }
            }
          }
        }
        if (added && !_rafScheduled) {
          _rafScheduled = true;
          requestAnimationFrame(_flushPending);
        }
      }).observe(document.body, { childList: true, subtree: true });
      // Body class observer kept lightweight — attributeFilter narrowly scoped
      new MutationObserver(_stripBodyOpenClasses)
        .observe(document.body, { attributes: true, attributeFilter: ['class'] });
      // Pre-existing sweep
      document.querySelectorAll('[id*="oxify" i], [id*="ia-upsell" i], [class*="oxify" i], [class*="ia-upsell" i], [class*="cart-drawer" i], [class*="cart-popup" i], [class*="cart-modal" i]')
        .forEach(_hideOxifyish);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _setupBodyObservers);
    } else {
      _setupBodyObservers();
    }

    // 2026-05-12 v9 — Cart-drawer global monkey-patch with continuous re-wrap.
    // Oxify and other cart apps assign their drawer-open functions at unknown
    // times during page load (sometimes after a setTimeout). If we wrap once
    // and Oxify reassigns later, our wrap is gone. So we POLL for 30 seconds:
    // every 200ms, re-check that each known global is still our wrapped version.
    // When the user has explicitly clicked the cart icon (`tnf-cart-allow-open`
    // set on <html>), the wrapped version calls the original; otherwise it's a
    // silent no-op + cart icon pulse.
    var _origCartFns = {};
    function _wrapCartOpener(name) {
      try {
        var current = window[name];
        if (typeof current !== 'function') return;
        if (current._tnfWrapped) return;
        // Save the original (could be Oxify's real function we're wrapping)
        _origCartFns[name] = current;
        var wrapped = function () {
          if (document.documentElement.classList.contains('tnf-cart-allow-open')) {
            return _origCartFns[name].apply(this, arguments);
          }
          pulseCart();
        };
        wrapped._tnfWrapped = true;
        window[name] = wrapped;
      } catch (e) {}
    }
    var CART_GLOBALS = [
      'openIACartDrawer',     // Oxify Cart Drawer
      'toggleIACartDrawer',   // Oxify
      'openCartbite',         // Cartbite (also installed)
      'cartbite_open',
      'showCartbite',
      'openSideCart',         // generic
      'openMiniCart',
      'toggleMiniCart',
      'showCart',             // generic safety
      'openCartDrawer'
    ];
    function _patchCartGlobals() {
      for (var i = 0; i < CART_GLOBALS.length; i++) _wrapCartOpener(CART_GLOBALS[i]);
    }
    _patchCartGlobals();
    // Poll every 200ms for 30 seconds — catches Oxify reassigning after our wrap.
    var _patchInt = setInterval(_patchCartGlobals, 200);
    setTimeout(function () { clearInterval(_patchInt); }, 30000);

    // GLOBAL /cart/add submit intercept — covers EVERY surface that posts a cart-add
    // form (PDP, QB modal, sticky ATC, theme app embeds). We do the POST ourselves
    // so the theme's submit handler never runs → drawer can't be opened from this path.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.tagName || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitBtn = form.querySelector('[type="submit"], button[name="add"]');
      var prevHtml = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) { submitBtn.disabled = true; var sp = submitBtn.querySelector('span'); if (sp) sp.textContent = 'Adding…'; else submitBtn.textContent = 'Adding…'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          if (submitBtn) { submitBtn.disabled = false; var sp2 = submitBtn.querySelector('span'); if (sp2) sp2.textContent = '✓ Added'; else submitBtn.textContent = '✓ Added'; setTimeout(function () { submitBtn.innerHTML = prevHtml; }, 1400); }
          fireAfterAdd();
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = prevHtml; }
        });
    }, true);
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        var hit = isCartAddUrl(input);
        var p = origFetch.apply(this, arguments);
        if (hit) p.then(function (r) { if (r && (r.ok || r.status < 400)) fireAfterAdd(); }).catch(function () {});
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var XHR = window.XMLHttpRequest.prototype;
      var origOpen = XHR.open;
      var origSend = XHR.send;
      XHR.open = function (method, url) {
        try { this.__tnfHit = isCartAddUrl(url); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      XHR.send = function () {
        if (this.__tnfHit) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 400) fireAfterAdd();
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  })();

  function pulseCart() {
    var icon = findCartIcon();
    var count = findCartCountBadge();
    if (icon) {
      icon.classList.remove('tnf-cart-pulse');
      // Force reflow so animation restarts on rapid adds
      void icon.offsetWidth;
      icon.classList.add('tnf-cart-pulse');
      setTimeout(function () { icon.classList.remove('tnf-cart-pulse'); }, 700);
    }
    if (count) {
      count.classList.remove('tnf-cart-count-pulse');
      void count.offsetWidth;
      count.classList.add('tnf-cart-count-pulse');
      setTimeout(function () { count.classList.remove('tnf-cart-count-pulse'); }, 800);
    }
  }

  function watchCartDrawer() {
    var drawer = findCartDrawer();
    if (!drawer) {
      setTimeout(watchCartDrawer, 1000);
      return;
    }
    new MutationObserver(function () {
      if (isCartDrawerOpen(drawer) && Date.now() - lastCartIconClick > GRACE_MS) {
        // Auto-open detected — close it, pulse the icon
        closeCartDrawer(drawer);
        pulseCart();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open', 'style'] });

    // Also watch the body for cart-related open classes (some themes toggle on body)
    new MutationObserver(function () {
      var bodyOpen = document.body.classList.contains('mini-cart-open')
                  || document.body.classList.contains('drawer-open')
                  || document.body.classList.contains('is-mini-cart-open');
      if (bodyOpen && isCartDrawerOpen(drawer) && Date.now() - lastCartIconClick > GRACE_MS) {
        closeCartDrawer(drawer);
        pulseCart();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  // 2026-05-12: pulse the cart icon on EVERY add-to-cart, not only when we suppress
  // an auto-opened drawer. If the drawer doesn't try to auto-open (sticky ATC, Quick Buy,
  // PDP form, etc.), the old logic never fired the pulse and the user got no feedback.
  // DOM-based detection only (no fetch/XHR override — those broke the QB modal once).
  function watchCartCount() {
    function parseCount(el) {
      if (!el) return null;
      var txt = (el.textContent || el.getAttribute('data-cart-count') || '').replace(/[^0-9]/g, '');
      return txt === '' ? null : parseInt(txt, 10);
    }
    function attachToBadge(badge) {
      if (!badge || badge.dataset.tnfWatched === '1') return;
      badge.dataset.tnfWatched = '1';
      var last = parseCount(badge);
      new MutationObserver(function () {
        var cur = parseCount(badge);
        if (cur != null && last != null && cur > last) pulseCart();
        if (cur != null) last = cur;
      }).observe(badge, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-cart-count'] });
    }
    function sweep() {
      document.querySelectorAll(
        '.header__cart-count, [data-cart-count], .header__cart-count-bubble, .header-icons__count, .cart-count-bubble'
      ).forEach(attachToBadge);
    }
    sweep();
    // Cart count badges sometimes get re-rendered by section refresh — re-attach periodically.
    new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    watchCartDrawer();
    watchCartCount();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
